import { ExpandedRsp } from '@app/types/internal';

const makeValidRspsList = (rsps: ExpandedRsp[], hasPlTypes: boolean) => {
    const validRsps = rsps.reduce((acc, rsp) => {
        const rh = rsp?.rightsholder?.id;
        const sp = rsp?.sponsor?.id;
        const pl = `${rsp?.rightsholder?.id}-${rsp?.placement?.id}`;
        const plType = hasPlTypes ? `_${rsp?.placementType?.id}` : '';

        const currRspId = `${rh}_${sp}_${pl}${plType}`;

        acc.push(currRspId);
        return acc;
    }, []);

    return validRsps;
};

export default makeValidRspsList;
